import RecapBase from "./RecapBase";

const SeasonRecap = () => (
  <RecapBase type="season" redirectPath="/season-recap" />
);

export default SeasonRecap;
